import type { FunctionComponent } from 'react';

import { FormGroup } from '../../../generic/Forms';

import ModalIssueExportField from './ModalIssueExportField';
import ModalIssueExportTrackerPicker from './ModalIssueExportTrackerPicker';
import type { JiraExportFieldsWithOnChange } from './useJiraExport';
import type { TrackerExportType } from './useTrackerExportPicker';

type ModalIssueExportFieldsProps = JiraExportFieldsWithOnChange & {
  trackerType: TrackerExportType;
  onTrackerTypeChange: (trackerType: TrackerExportType) => void;
  hasGitHub: boolean;
  hasJiras: boolean;
};

/**
 * Renders the required and (if there are any) optional fields.
 */
const ModalIssueExportFields: FunctionComponent<ModalIssueExportFieldsProps> = ({
  required,
  optional,
  trackerType,
  onTrackerTypeChange,
  hasGitHub,
  hasJiras,
}) => {
  const shouldDisplayJiraFields = hasJiras && trackerType === 'jira';
  return (
    <section className="modal-issue-export__fields">
      <legend className="modal-issue-export__fields__heading">
        Tracker
      </legend>
      <FormGroup>
        <ModalIssueExportTrackerPicker
          trackerType={trackerType}
          isDisabled={!hasGitHub || !hasJiras}
          onTrackerTypeChange={onTrackerTypeChange}
        />
      </FormGroup>
      {shouldDisplayJiraFields && (
        <>
          <legend className="modal-issue-export__fields__heading">
            Required
          </legend>
          <FormGroup>
            {required.map(field => (
              <ModalIssueExportField
                key={field.id}
                {...field} // eslint-disable-line react/jsx-props-no-spreading
              />
            ))}
          </FormGroup>
          {optional.length > 0 && (
            <>
              <legend className="modal-issue-export__fields__heading">
                Optional
              </legend>
              <FormGroup>
                {optional.map(field => (
                  <ModalIssueExportField
                    key={field.id}
                    {...field} // eslint-disable-line react/jsx-props-no-spreading
                  />
                ))}
              </FormGroup>
            </>
          )}
        </>
      )}
    </section>
  );
};

export default ModalIssueExportFields;
